// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/* Контроль и оповешение наличия торговых нумериков с ошибкой (https://tp.traderevolution.com/entity/98089 появился в связи с возможностью отправить ордер с пустыми торговыми нумериками (которые используют предыдущее валидное значение) )
                          |
       Вызов строчки ниже v вернет true и вызовет отображения окна с errorText в случае наличия торговых нумериков с hasError = true,enabled=true  */
// TradingNumericErrorChecker.HasErrors(parent /*родительский контрол нумерики которого надо проверить в .Controls*/)
/*      Для оптимизации работы подписывается на TerceraNumeric.OnHasErrorsChanged запоминая были ли в нумериках ошибки, а также были ли они позже исправлены, подсчитывает общее количество неисправленных ошибок для каждой родительской панели где случались ошибки
 Для использования вызвать TradingNumericErrorChecker.HasErrors(<родительский контрол нумерики которого надо проверить>) перед попыткой отправить ордер */
import { messageBoxHandler, terceraNumericHandler } from '@shared/utils/AppHandlers';
import { Resources } from '@shared/localizations/Resources';
export class _TradingNumericErrorChecker {
    constructor() {
        this.errorsNumber = 0; // общее кол-во неисправленных ошибок - если ноль при проверке, сразу выходим (иначе могут быть варианты: панель закрыли, другая панель, другой врк и т.д)
        this.cachedTradingNumericsWithErrors = {}; // запоминаем нумерики в которых были допущены ошибки
        this.cachedByContainerID = {}; // для быстрого доступа кол-во неисправностей по guid контейнера
    }
    OnHasErrorsChanged(numeric, hasError) {
        // процесс кэширования нумериков с ошибкой или ее исправлением
        if (!(numeric === null || numeric === void 0 ? void 0 : numeric._guid)) {
            return;
        }
        const id = numeric._guid;
        const parent = _TradingNumericErrorChecker.getZeroParentByNumeric(numeric);
        const parentID = parent._guid;
        if (hasError) {
            if (!this.cachedTradingNumericsWithErrors[id]) {
                if (!this.cachedByContainerID[parentID]) {
                    this.cachedByContainerID[parentID] = 0;
                }
                this.cachedByContainerID[parentID]++; // увеличиваем общее кол-во неисправленных ошибок по панеле (контейнеру содержащиму нумерик)
                this.cachedTradingNumericsWithErrors[id] = numeric; // запоминаем нумерик с ошибкой + parent._guid
            }
        }
        else if (this.cachedTradingNumericsWithErrors[id]) {
            this.cachedTradingNumericsWithErrors[id] = null; // нумерик с ошибкой исправился
            this.cachedByContainerID[parentID]--;
        }
    }
    HasErrors(parent) {
        const zeroParent = _TradingNumericErrorChecker.getZeroParentByNumeric(parent);
        const parentID = zeroParent._guid;
        const hasErrorsInThisContainer = this.cachedByContainerID[parentID] > 0;
        if (!hasErrorsInThisContainer) // если неисправленных ошибок нет - сразу выходим
         {
            return false;
        }
        const parentNumerics = parent.findAllComponents('terceraNumeric');
        const parentNumericsIDs = parentNumerics.map((n) => n._guid);
        for (const id in this.cachedTradingNumericsWithErrors) {
            const numeric = this.cachedTradingNumericsWithErrors[id];
            if (parentNumericsIDs.includes(numeric === null || numeric === void 0 ? void 0 : numeric._guid) && numeric.get('hasError') && numeric.get('enabled')) {
                const errorText = numeric.get('customErrorText') || numeric.get('errorText');
                messageBoxHandler.Show(Resources.getResource('screen.error.title'), errorText, messageBoxHandler.msgType.Error, null, null, false, true);
                return true;
            }
        }
        return false;
    }
    static getZeroParentByNumeric(control) {
        if (!control)
            return null;
        const parent = control.parent;
        if (!parent) {
            return control;
        }
        return _TradingNumericErrorChecker.getZeroParentByNumeric(parent);
    }
    subscribeToHandler() {
        terceraNumericHandler.OnHasErrorsChanged.Subscribe(this.OnHasErrorsChanged, this);
    }
}
export const TradingNumericErrorChecker = new _TradingNumericErrorChecker();
